import React from 'react'
import Manager from 'tyan/public/components/Manager'
import AdvanceOrder from './AdvanceOrder'
import AddExpenseOrder from './AddExpenseOrder'
Ext.require('Ext.Toast')

const config = {
    tabs: {
        申请中: {
            buttons: [
                { text: '申请...', handler: ({ showDetail, refreshPage }) => showDetail(props => <AdvanceOrder {...props} id={0} />) },
            ],
            columns: [
                { _text: '预支单号', field: 'Number', minWidth: 150, flex: 1, search: true },
                { _text: '预支对象', field: 'CustomerName', minWidth: 200, flex: 1, search: true },
                { _float: '预支金额', field: 'AdvanceAmount', minWidth: 150, flex: 1 },
                { _text: '币别', field: 'Currency', minWidth: 100, flex: 1, search: true },
                { _text: '请购单号', field: 'PurchaseOrderNo', minWidth: 150, flex: 1, search: true },
                { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1, search: true },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, search: true },
                { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <AdvanceOrder {...props} id={data.id} />)
            }
        },
        被退回: {
            buttons: [
            ],
            columns: [
                { _text: '预支单号', field: 'Number', minWidth: 150, flex: 1, search: true },
                { _text: '预支对象', field: 'CustomerName', minWidth: 200, flex: 1, search: true },
                { _float: '预支金额', field: 'AdvanceAmount', minWidth: 150, flex: 1 },
                { _text: '币别', field: 'Currency', minWidth: 100, flex: 1, search: true },
                { _text: '请购单号', field: 'PurchaseOrderNo', minWidth: 150, flex: 1, search: true },
                { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1, search: true },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, search: true },
                { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
                { _text: '退回原因', field: 'ReturnReason', minWidth: 150, flex: 1 },
                { _: 'taskName', field: 'Task.TaskName' }
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <AdvanceOrder {...props} id={data.id} taskName={data.taskName} />)
            }
        },
        待打印: {
            buttons: [
            ],
            columns: [
                { _text: '预支单号', field: 'Number', minWidth: 150, flex: 1, search: true },
                { _text: '预支对象', field: 'CustomerName', minWidth: 200, flex: 1, search: true },
                { _float: '预支金额', field: 'AdvanceAmount', minWidth: 150, flex: 1 },
                { _text: '币别', field: 'Currency', minWidth: 100, flex: 1, search: true },
                { _text: '请购单号', field: 'PurchaseOrderNo', minWidth: 150, flex: 1, search: true },
                { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1, search: true },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, search: true },
                { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
                // { _text: '退回原因', field: 'ReturnReason', minWidth: 150, flex: 1 },
                // { _: 'taskName', field: 'Task.TaskName' }
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <AdvanceOrder {...props} id={data.id} taskName={data.taskName} />)
            }
        },
        签核中: {
            buttons: [
            ],
            columns: [
                { _text: '预支单号', field: 'Number', minWidth: 150, flex: 1, search: true },
                { _text: '预支对象', field: 'CustomerName', minWidth: 200, flex: 1, search: true },
                { _float: '预支金额', field: 'AdvanceAmount', minWidth: 150, flex: 1 },
                { _text: '币别', field: 'Currency', minWidth: 100, flex: 1, search: true },
                { _text: '请购单号', field: 'PurchaseOrderNo', minWidth: 150, flex: 1, search: true },
                { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1, search: true },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, search: true },
                { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <AdvanceOrder {...props} id={data.id} readOnly={true} />)
            }
        },
        待确认: {
            buttons: [
            ],
            columns: [
                { _text: '预支单号', field: 'Number', minWidth: 150, flex: 1, search: true },
                { _text: '预支对象', field: 'CustomerName', minWidth: 200, flex: 1, search: true },
                { _float: '预支金额', field: 'AdvanceAmount', minWidth: 150, flex: 1 },
                { _text: '币别', field: 'Currency', minWidth: 100, flex: 1, search: true },
                { _text: '请购单号', field: 'PurchaseOrderNo', minWidth: 150, flex: 1, search: true },
                { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1, search: true },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, search: true },
                { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <AdvanceOrder {...props} id={data.id} />)
            }
        },
        待报支: {
            buttons: [
            ],
            columns: [
                { _text: '预支单号', field: 'Number', minWidth: 150, flex: 1, search: true },
                { _text: '预支对象', field: 'CustomerName', minWidth: 200, flex: 1, search: true },
                { _float: '预支金额', field: 'AdvanceAmount', minWidth: 150, flex: 1 },
                { _text: '币别', field: 'Currency', minWidth: 100, flex: 1, search: true },
                { _text: '请购单号', field: 'PurchaseOrderNo', minWidth: 150, flex: 1, search: true },
                { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1, search: true },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, search: true },
                { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
                { _: 'taskName', field: 'Task.TaskName' },
                {
                    _button: '生成报支单...', locked: 'right', icon: 'edit', minWidth: 120, handler: ({ showDetail, refreshPage }, data) => {
                        Tyan.pubForm.showDialog('生成报支单', props => <AddExpenseOrder {...props} id={0} advanceExpenseID={data.id} onSave={refreshPage} showDetail={showDetail} />)
                    }
                },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <AdvanceOrder {...props} id={data.id} taskName={data.taskName} readOnly={true} />)
            }
        },
        报支中: {
            buttons: [
            ],
            columns: [
                { _text: '预支单号', field: 'Number', minWidth: 150, flex: 1, search: true },
                { _text: '预支对象', field: 'CustomerName', minWidth: 200, flex: 1, search: true },
                { _float: '预支金额', field: 'AdvanceAmount', minWidth: 150, flex: 1 },
                { _text: '币别', field: 'Currency', minWidth: 100, flex: 1, search: true },
                { _text: '请购单号', field: 'PurchaseOrderNo', minWidth: 150, flex: 1, search: true },
                { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1, search: true },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, search: true },
                { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <AdvanceOrder {...props} id={data.id} readOnly={true} />)
            }
        },
        已完成: {
            buttons: [
            ],
            columns: [
                { _text: '预支单号', field: 'Number', minWidth: 150, flex: 1, search: true },
                { _text: '预支对象', field: 'CustomerName', minWidth: 200, flex: 1, search: true },
                { _float: '预支金额', field: 'AdvanceAmount', minWidth: 150, flex: 1 },
                { _text: '币别', field: 'Currency', minWidth: 100, flex: 1, search: true },
                { _text: '请购单号', field: 'PurchaseOrderNo', minWidth: 150, flex: 1, search: true },
                { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1, search: true },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, search: true },
                { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <AdvanceOrder {...props} id={data.id} />)
            }
        },
    }
}

export default props => <Manager {...props} config={config} />